import React, { useEffect, useState } from "react";
import {
  EyeIcon,
  EyeOffIcon,
  LockClosedIcon,
  UserCircleIcon,
} from "@heroicons/react/outline";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  getResetLinkRequest,
  clearLoginSuccess,
  clearGetResetLinkSuccess,
} from "../../redux/action";
import toast from "react-hot-toast";
import { RegisterButton } from "../Buttons";
import { FormError } from "./FormError";

export const ForgotPasswordForm = ({ isAdmin }) => {
  const [passType, setPassType] = useState(true);

  const history = useHistory();

  const dispatch = useDispatch();

  const { getResetLinkSuccess, getResetLinkError, getResetLinkLoading, user } =
    useSelector((state) => {
      const {
        success: { getResetLink: getResetLinkSuccess },
        errors: { getResetLink: getResetLinkError },
      } = state.ajaxStatuses;

      const { getResetLinkLoading } = state.loadingIndicator;

      const { user } = state.userData;

      return {
        getResetLinkSuccess,
        getResetLinkError,
        getResetLinkLoading,
        user,
      };
    });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: yup.object({
      email: yup.string().required("Enter email"),
    }),

    onSubmit: (prop) => {
      dispatch(getResetLinkRequest(prop));
    },
  });

  useEffect(() => {
    if (getResetLinkError) {
      toast.error(getResetLinkError, {
        duration: 3000,
      });
    }
  }, [getResetLinkError]);

  useEffect(() => {
    if (getResetLinkSuccess) {
      toast.success(getResetLinkSuccess, {
        duration: 7000,
      });

      dispatch(clearGetResetLinkSuccess());
    }
  }, [getResetLinkSuccess]);

  return (
    <div className="shadow  py-16 px-4  md:px-8 md:py-8  ">
      <div className="text-3xl">Forgot password</div>
      <form onSubmit={formik.handleSubmit} className="grid grid-cols-1 ">
        <div className="grid grid-rows-1  mb-10">
          <div className="pt-8">
            <div>
              <div className="flex items-center  ">
                <UserCircleIcon className="h-6 text-gray-600 mr-2" />
                <input
                  type="text"
                  className="py-2 px-4 w-full   border border-darkNav   focus:outline-none placeholder-gray-200::placeholder placeholder-opacity-75  "
                  placeholder="email"
                  name="email"
                  {...formik.getFieldProps("email")}
                />
              </div>
              {formik.errors.email && formik.touched.email && (
                <FormError message={formik.errors.email} />
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-col">
          <RegisterButton
            loading={getResetLinkLoading}
            disable={!(formik.dirty && formik.isValid)}
            action={formik.handleSubmit}
            text="Get reset link"
          />
        </div>
      </form>
    </div>
  );
};
